<template>
  <v-row>
    <v-col cols="6" sm="2">
      <decimal-number-input label="Cases" v-model="casesInput" :precision="0" integer prefix="" suffix="" :disabled="bottlesOnly"
                            :hint="estCases" persistent-hint/>
    </v-col>
    <v-col cols="6" sm="2">
      <decimal-number-input label="Bottles" v-model="bottlesInput" :precision="0" integer prefix="" suffix=""
                            :hint="estBottles" persistent-hint/>
    </v-col>
    <v-col cols="6" sm="2">
      <v-switch label="Bottles only" v-model="bottlesOnly" dense class="mt-1" @click="adjustQuantities()" :disabled="!caseSize"/>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CasesBottles',
  props: {
    cases: {type:Number, required:true},
    bottles: {type:Number, required:true},
    caseSize: {type:Number, required:false},
    availableCount: {type:Number, required:false},
    avaiablePrefix: {type:String, required:false, default:''},
    avaiableSuffix: {type:String, required:false, default:''}
  },
  data() {
    return {
      casesInput: this.cases,
      bottlesInput: this.bottles,
      bottlesOnly: false,
      estCases: '',
      estBottles: ''
    }
  },
  watch: {
    cases() {
      this.casesInput = this.cases;
    },
    bottles() {
      this.bottlesInput = this.bottles;
    },
    casesInput() {
      this.$emit('update:cases', this.casesInput);
      this.$emit('change');
    },
    bottlesInput() {
      this.$emit('update:bottles', this.bottlesInput);
      this.$emit('change');
    },
    availableCount() {
      this.available();
    }
  },
  methods: {
    adjustQuantities() {
      if (this.bottlesOnly) {
        this.bottlesInput += this.casesInput * this.caseSize;
        this.casesInput = 0;
      }
      else {
        this.casesInput = Math.floor(this.bottlesInput / this.caseSize);
        this.bottlesInput -= this.casesInput * this.caseSize;
      }
      this.available();
    },
    available() {
      if (this.caseSize) {
        const cases = this.bottlesOnly ? 0 : Math.floor(this.availableCount / this.caseSize);
        const bottles = this.availableCount - cases * this.caseSize;
        this.estCases = this.bottlesOnly ? '' : `${this.avaiablePrefix} ${cases} ${this.avaiableSuffix}`;
        this.estBottles = `${this.avaiablePrefix} ${bottles} ${this.avaiableSuffix}`;
      }
    }
  }
}
</script>